import { HeadingWithDecorProps } from "@/types/components/HeadingWithDecorProps";
import { Icon } from "@iconify/react/dist/iconify.js";
import { PropsWithChildren } from "react";

const HeadingWithDecor = ({ as: Component = 'p', className = '', decor = 'bar', size = 'h4', children }: PropsWithChildren<HeadingWithDecorProps>) => {
    return(
        <div className="items-center relative flex gap-x-2 mb-4">
            {decor === 'bar' &&
                <div className="border-accordorange border-l-[2px] h-full absolute left-0"></div>
            }
            {decor === 'bolt' &&
                <Icon icon={`iconamoon:lightning-2-fill`} className="text-accordorange" width={32}/>
            }
            <Component className={`
                ${size === 'h4' ? 'h4' : ''} 
                ${size === 'h3' ? 'h3' : ''} 
                text-arcticMist font-semibold tracking-[0.48px] ${decor !== 'bolt' ? 'pl-2' : ''}
            `}>
                {children}
            </Component>
        </div>
    )
}

export default HeadingWithDecor